import { render, staticRenderFns } from "./VehicleIconGuidelines.vue?vue&type=template&id=1023d530&scoped=true&"
import script from "./VehicleIconGuidelines.vue?vue&type=script&lang=js&"
export * from "./VehicleIconGuidelines.vue?vue&type=script&lang=js&"
import style0 from "./VehicleIconGuidelines.vue?vue&type=style&index=0&id=1023d530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023d530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
